import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_MOD_NAME, ENUM_ADVSEARCH_PARAM, ENUM_MOD_PARAMETER, GetLoginCredentialDb, getModValue, linksUrl, SALE_PUR_ENTRY_TYPE } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faPlus,
  faReceipt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"

import ReportViewer from "../report/ReportViewer"
import { enum_Report_Type } from "../report/ReportUtility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, setDetailParams, setNewEntryMode } from "../../state/purchaseEntrySlice"


const PurchaseEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
  let [itemToDelete, setItemToDelete] = useState("")
  const [tradeOf, setTradeOf] = useState()
  const [entryLabel, setEntryLabel] = useState("")
  const [selAdvanceFilter, setSelAdvanceFilter] = useState({})
  const [pageApiAdvFilter, setPageApiAdvFilter] = useState({})
  const [data, setData] = useState([])

  //let [data, setData] = useState([])
  const { typeid } = useParams();
  //console.log(typeid)

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard.tradingDashboard)

    const params = [SALE_PUR_ENTRY_TYPE.GrayCloth, SALE_PUR_ENTRY_TYPE.Yarn, SALE_PUR_ENTRY_TYPE.Millgin, SALE_PUR_ENTRY_TYPE.General]
    if (!params.includes(String(typeid)))
      navigate(linksUrl.dashboard.tradingDashboard)

    disapatch(resetDetailParams())

    if (typeid && typeid != "") {
      let t_tradeof = ''
      let t_entryLabel = ''
      let t_typeid = typeid.toLowerCase()
      if (t_typeid == SALE_PUR_ENTRY_TYPE.GrayCloth.toLowerCase()) {
        t_tradeof = 'C'
        t_entryLabel = "Gray Cloth Purchase"
      }
      else if (t_typeid == SALE_PUR_ENTRY_TYPE.Yarn.toLowerCase()) {
        t_tradeof = 'Y'
        t_entryLabel = "Yarn Purchase"
      }
      else if (t_typeid == SALE_PUR_ENTRY_TYPE.Millgin.toLowerCase()) {
        t_tradeof = 'M'
        t_entryLabel = "Millgin Purchase"
      }
      else if (t_typeid == SALE_PUR_ENTRY_TYPE.General.toLowerCase()) {
        t_tradeof = 'G'
        t_entryLabel = "General Purchase"
      }
      setTradeOf(t_tradeof)
      setEntryLabel(t_entryLabel)
      funFilterData(t_tradeof, null, null, null, null, null, null, null, null);
      setPageApiAdvFilter({ CompCode: compCode.join(','), BillType: 'S', TradeOf: t_tradeof })
    }
  }, [typeid])

  const {
    isOpen: isOpenReportModel,
    onOpen: onOpenReportModel,
    onOpenChange: onOpenReportModelChange,
  } = useDisclosure()

  const {
    isError,
    isPending,
    data: purData = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.transaction.PurchaseEntry.fetch,
    queryKey: "Purchase Data List",

  })
  const funFilterData = (trade, itemcode, pacid, brid, fromdate, todate, status, fduedate, tduedate) => {
    filterData({
      data: {
        compcode: compCode.join(","),
        tradeof: String(trade),
        item_code: itemcode,
        pac_id: pacid,
        br_id: brid,
        from_date: fromdate,
        to_date: todate,
        status: status,
        fdue_date: fduedate,
        tdue_date: tduedate
      }
    })

  }
  useEffect(() => {
    setData(purData)
  }, [purData])
  //   const [isManualEntry, setIsManualEntry] = useState(false)
  //   const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
  //     url: apiRoute.modeSetting.getModSetting,
  //     queryKey: "fetchModSetting",
  //     inputData: {
  //       mod_name: ENUM_MOD_NAME.GrayStock
  //     }
  //   })



  const onSuccessDelete = (data) => {
    setItemToDelete("")
    toast.success("deleted successfully", {
      position: "top-center"
    })
    funFilterData(tradeOf, null, null, null, null, null, null, null, null);
  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.transaction.PurchaseEntry.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalAmt = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "invoice_amount",
      }),
    [data]
  )

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "party_name",
    "Invoice_Det",
    "invoice_no",
    "invoice_amount",
    "invoice_date",
    "due_date",
    "account_name",
    "status"

  ]

  const exportColumns = [
    {
      name: "PARTY NAME",
      uid: "party_name",
    },
    {
      name: "Items",
      uid: "Invoice_Det",
    },
    {
      name: "BILL NO",
      uid: "invoice_no",
    },
    {
      name: "AMOUNT",
      uid: "invoice_amount",
    },
    {
      name: "BILL DATE",
      uid: "invoice_date",
      type:COLUMN_TYPE.date
    },
    {
      name: "DUE DATE",
      uid: "due_date",
      type:COLUMN_TYPE.date
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
    },
    {
      name: "STATUS",
      uid: "status",
    },
  ]

  let downloadDataFooter = {
    party_name: "",
    Invoice_Det: "",
    invoice_no: "",
    invoice_amount: "Total: " + totalAmt,
    invoice_date: "",
    due_date: "",
    account_name: "",
  }


  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "PARTY NAME",
      uid: "party_name",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Items",
      uid: "Invoice_Det",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.multiline
    },
    {
      name: "BILL NO",
      uid: "invoice_no",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "AMOUNT",
      uid: "invoice_amount",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmt,
      },
    },
    {
      name: "Bill DATE",
      uid: "invoice_date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "DUE DATE",
      uid: "due_date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "STATUS",
      uid: "status",
      align: COLUMN_ALIGN_TYPE.center,

    },
  ]

  const handleConfirmBox = (data) => {
    if (data) {

      FndeleteNote({
        data: {
          transaction_id: itemToDelete.transaction_id,
          comp_code: itemToDelete.comp_code,
          chalno: itemToDelete.chal_no,
          manual_entry: true,
          trade_of: tradeOf

        }
      })
    }
    else {
      setItemToDelete("")
    }

  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        let obj = {
          comp_code: row.compcode,
          transaction_id: row.TransactionId,
          bill_type: 'P',
          bill_no: row.invoice_no

        }
        disapatch(setDetailParams(obj))
        disapatch(setNewEntryMode(false))
        navigate(linksUrl.transaction.PurchaseEntry + typeid + "/create-entry")
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {
        setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.compcode, trn_no: row.Trn_No, chal_no: row.invoice_no })
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    // {
    //   icon: <FontAwesomeIcon color="#0a4da6" icon={faReceipt} />,
    //   onClick: (row) => {
    //     let obj = {
    //       token: token,
    //       comp_code: row.compcode,
    //       acid: null,
    //       billno: row.invoice_no,
    //       billtype: "S",
    //       db_user: GetLoginCredentialDb(user, yearId)
    //     }
    //     disapatch(resetReportDetail())
    //     disapatch(setInvoiceDetail(obj))
    //     // navigate(linksUrl.report.invoice.rptInvoice)
    //     onOpenReportModel()
    //   },
    //   label: "print",
    //   type: ROW_ACTION_BTN_TYPE.link,
    // },
  ]

  const handleAddNew = () => {
    disapatch(resetDetailParams())
    navigate(linksUrl.transaction.PurchaseEntry + typeid + "/create-entry")
  }


  const reportModel = () => {
    return (
      <div>
        <Modal
          isOpen={isOpenReportModel}
          onOpenChange={onOpenReportModelChange}
          size="xl"
          placement="center"
        >
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="flex flex-row gap-1">
                  Stock
                </ModalHeader>
                <ModalBody className="overflow-auto ">
                  <div className="flex flex-col">
                    <ReportViewer props_ReportType={enum_Report_Type.DBCRNote} />
                  </div>
                </ModalBody>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    )
  }
  const ADVFILTER_VISIBLE_FIELD = [
    // ...Object.values(ENUM_ADVSEARCH_PARAM)
    ENUM_ADVSEARCH_PARAM.Status,
    ENUM_ADVSEARCH_PARAM.Party,
    ENUM_ADVSEARCH_PARAM.Broker,
    ENUM_ADVSEARCH_PARAM.Item,
    ENUM_ADVSEARCH_PARAM.VouFromDate,
    ENUM_ADVSEARCH_PARAM.VouToDate,
    ENUM_ADVSEARCH_PARAM.DueFromDate,
    ENUM_ADVSEARCH_PARAM.DueToDate,
    //  ENUM_ADVSEARCH_PARAM.VouNo,

  ]

  // useEffect(() => {
  //   if (selAdvanceFilter && Object.keys(selAdvanceFilter).length > 0) {
  //     Object.entries(selAdvanceFilter).map(([key, value]) => {
  //       console.log(key, value)
  //     })
  //   }
  //   console.log(selAdvanceFilter)
  // }, [selAdvanceFilter])

  const handleFilterChange = (newFilters) => {

    setSelAdvanceFilter(newFilters)

    funFilterData(tradeOf,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Item) ? newFilters[ENUM_ADVSEARCH_PARAM.Item] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Party) ? newFilters[ENUM_ADVSEARCH_PARAM.Party] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Broker) ? newFilters[ENUM_ADVSEARCH_PARAM.Broker] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouFromDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouToDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Status) ? newFilters[ENUM_ADVSEARCH_PARAM.Status] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.DueFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.DueFromDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.DueToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.DueToDate] : null,


    )

  }


  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  return (
    <div>
      {reportModel()}
      {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}

      <MainContainer
        pageName={entryLabel}
        info={[]}
        breadcrumbs={["Purchase", entryLabel]}
      >
        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>
      
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="Puchase-List"
          id="TransactionId"
          advanceFilterParam={selAdvanceFilter}
          advFilterPageApiParam={pageApiAdvFilter}
          advFilterVisibleField={ADVFILTER_VISIBLE_FIELD}
          onFilterChange={handleFilterChange}
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default PurchaseEntryMaster
